import React from 'react';
import styled from 'styled-components';
import { Grid, Color, Border, Type } from '../../app/StyleGuide';
import WhiteLabel from '../../filters/WhiteLabel';
import { createCurriculum } from '../../hooks/useCurriculum';

export const CurriculumItem = styled.div`
  align-items: center;
  padding: ${Grid._5} 0;
  transition: all 0.15s ease-in-out;
  min-height: 119px;
  border-bottom: 1px solid ${Color.Blue._15};

  &:hover {
    background: ${Color.white};
    cursor: pointer;
    h4 {
      text-decoration: underline;
    }
  }

  div:last-child {
    align-items: center;

    h4 {
      color: ${Type.Color.dark};
      font-size: ${Type.Scale._3};
      font-weight: ${Type.Weight.semibold};
      margin: 0;
    }

    p {
      color: ${Type.Color.medium};
      font-weight: ${Type.Weight.normal};
      margin: 0;
    }
  }
`;
